<div class="locations-card">
<loading [isLoading]="isLoading"></loading>
    <div class="locations-card-top">
        <div class="top-left">
            <h2>Recursos con GPS</h2>
        </div>
    </div>

    <div class="locations-card-bottom">
    
        <div class="circle-section">
            <div class="circle-container">
                <svg class="percent-circle" [attr.viewBox]="'0 0 ' + circleSize + ' ' + circleSize" preserveAspectRatio="xMidYMid meet">
                    <!--circulo 1-->
                    <circle
                        class="percent-circle-bg"
                        [attr.stroke-width]="strokeWidth"
                        fill="transparent"
                        [attr.r]="radius"
                        [attr.cx]="circleSize / 2"
                        [attr.cy]="circleSize / 2"
                    />
                    <!--circulo encima-->
                    <circle
                        class="percent-circle-fg online"
                        [attr.stroke-width]="strokeWidth"
                        fill="transparent"
                        [attr.r]="radius"
                        [attr.cx]="circleSize / 2"
                        [attr.cy]="circleSize / 2"
                        [attr.stroke-dasharray]="circumference"
                        [attr.stroke-dashoffset]="getCircleOffset(onlinePercent)"
                    />
                </svg>
                <div class="circle-text">
                    <span class="circle-percent">{{ onlinePercent }}%</span>
                </div>
            </div>
            <div class="circle-label-container">
                <span class="circle-label label-online">Online</span>
            </div>
        </div>
    
        <div class="circle-section">
            <div class="circle-container">
                <svg class="percent-circle" [attr.viewBox]="'0 0 ' + circleSize + ' ' + circleSize" preserveAspectRatio="xMidYMid meet">
                    <circle
                        class="percent-circle-bg"
                        [attr.stroke-width]="strokeWidth"
                        fill="transparent"
                        [attr.r]="radius"
                        [attr.cx]="circleSize / 2"
                        [attr.cy]="circleSize / 2"
                    />
                    <circle
                        class="percent-circle-fg offline"
                        [attr.stroke-width]="strokeWidth"
                        fill="transparent"
                        [attr.r]="radius"
                        [attr.cx]="circleSize / 2"
                        [attr.cy]="circleSize / 2"
                        [attr.stroke-dasharray]="circumference"
                        [attr.stroke-dashoffset]="getCircleOffset(offlinePercent)"
                    />
                </svg>
                <div class="circle-text">
                    <span class="circle-percent">{{ offlinePercent }}%</span>
                </div>
            </div>
            <div class="circle-label-container">
                <span class="circle-label label-offline">Offline</span>
            </div>
        </div>
    
        <div class="circle-section">
            <div class="circle-container">
                <svg class="percent-circle" [attr.viewBox]="'0 0 ' + circleSize + ' ' + circleSize" preserveAspectRatio="xMidYMid meet">
                    <circle
                        class="percent-circle-bg"
                        [attr.stroke-width]="strokeWidth"
                        fill="transparent"
                        [attr.r]="radius"
                        [attr.cx]="circleSize / 2"
                        [attr.cy]="circleSize / 2"
                    />
                    <circle
                        class="percent-circle-fg noReport"
                        [attr.stroke-width]="strokeWidth"
                        fill="transparent"
                        [attr.r]="radius"
                        [attr.cx]="circleSize / 2"
                        [attr.cy]="circleSize / 2"
                        [attr.stroke-dasharray]="circumference"
                        [attr.stroke-dashoffset]="getCircleOffset(noReportPercent)"
                    />
                </svg>
                <div class="circle-text">
                    <span class="circle-percent">{{ noReportPercent }}%</span>
                </div>
            </div>
            <div class="circle-label-container">
                <span class="circle-label label-noReport">Sin Reporte</span>
            </div>
        </div>
    
    </div>
</div>